"use strict";
/** state: Final **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SingleSelect_1 = require("../SingleSelect");
/**
 * TimePickers allow the user to select times by intervals.
 *
 * Also see {{DatePicker}}.
 */
var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            options: _this.getOptions(),
        };
        return _this;
    }
    TimePicker.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, step = _a.step, restProps = __rest(_a, ["onChange", "step"]);
        return (React.createElement(SingleSelect_1.SingleSelect, __assign({ onChange: function (e) { return onChange(e.target.value); } }, restProps), this.state.options.map(function (item) { return (React.createElement(SingleSelect_1.SingleSelect.Option, { value: item.value, key: item.value }, item.label)); })));
    };
    TimePicker.prototype.getOptions = function () {
        var hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        var minutes = Array();
        for (var i = 0; i < 60; i++) {
            if (i % this.props.step === 0) {
                minutes.push(i < 10 ? "0" + i : i);
            }
        }
        var amPm = ['AM', 'PM'];
        var labels = hours.reduce(function (acc, hour) {
            var items = minutes.map(function (minute) { return hour + ":" + minute; });
            acc.push.apply(acc, items);
            return acc;
        }, []);
        return amPm.reduce(function (acc, amPmItem) {
            var items = labels.map(function (lblItem) { return ({
                label: lblItem + " " + amPmItem,
                value: lblItem + " " + amPmItem,
            }); });
            acc.push.apply(acc, items);
            return acc;
        }, []);
    };
    TimePicker.defaultProps = {
        step: 30,
    };
    return TimePicker;
}(React.Component));
exports.TimePicker = TimePicker;
//# sourceMappingURL=TimePicker.js.map